<template>
  <div name="demo-searchbox-codcomp">
    <div class="row">
      <div class="form-group col-xs-12 col-md-6">
        <hrms-lov-codcomp v-model="codcomp1"
                           :nowLang="nowLang"
                           name="codcomp1"
                           :descDisp="false" />
        <hrms-lov-codcomp v-model="codcomp1"
                           :disabled="true"
                           :nowLang="nowLang"
                           name="codcomp1"
                           :descDisp="false" />
        <hrms-lov-codcomp v-model="codcomp2"
                           :nowLang="nowLang"
                           name="codcomp2" />
      </div>
    </div>
    <hrms-search-box  v-model="searchIndex" 
                      :receivedStore="receivedStore"
                      :nowLang="nowLang"
                      searchBoxAlias="demo-lov-codcomp" />
  </div>
</template>

<script>
import env from 'src/../env.js'

export default {
  name: 'demo-searchbox-codcomp',
  data () {
    return {
      codcomp1: '',
      codcomp2: '',
      searchIndex: {
        codcomp: ''
      },
      nowLang: window.localStorage.getItem(env.site + '_lang')
    }
  },
  methods: {
    receivedStore (params) {
      console.log(params)
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoSearchboxCodcomp.vue?c0322d42